import { useUpdateFixtureRosterPlayerDc, useUpdateFixtureRosterPlayerInternal } from "hooks/useFixtureRosterApi";
import { useUpdateSeasonRosterPlayerDc, useUpdateSeasonRosterPlayerInternal } from "hooks/useSeasonRosterApi";
import { useCallback, useRef } from "react";

type Props = {
  entityId: string;
  seasonId: string;
  personId?: string;
  dcPersonId?: string;
  data: any;
  record: any;
};

export const useUpdateSeasonRosterPlayer = () => {
  const lastUpdateRef = useRef(undefined);

  const {
    isPending: isUpdatingInternalSeasonRoster,
    isSuccess: isSuccessInternalSeasonRoster,
    mutateAsync: updateInternalSeasonRoster,
  } = useUpdateSeasonRosterPlayerInternal();
  const {
    isPending: isUpdatingDcSeasonRoster,
    isSuccess: isSuccessDcSeasonRoster,
    mutateAsync: updateDcSeasonRoster,
  } = useUpdateSeasonRosterPlayerDc();

  const mutateAsync = useCallback(
    async ({ entityId, seasonId, personId, dcPersonId, data, record }: Props) => {
      lastUpdateRef.current = record;

      if (personId) {
        await updateInternalSeasonRoster({
          entityId,
          seasonId,
          personId: personId || "undefined",
          data,
        });
      } else if (dcPersonId) {
        await updateDcSeasonRoster({
          entityId,
          seasonId,
          dcPersonId: dcPersonId || "undefined",
          data,
        });
      }
    },
    [updateInternalSeasonRoster, updateDcSeasonRoster]
  );

  const isUpdating = isUpdatingInternalSeasonRoster || isUpdatingDcSeasonRoster;

  return {
    updatingRecord: isUpdating ? lastUpdateRef.current : undefined,
    mutateAsync,
    isUpdating,
    isSuccess: isSuccessInternalSeasonRoster && isSuccessDcSeasonRoster,
  };
};

export const useUpdateFixtureRosterPlayer = () => {
  const lastUpdateRef = useRef(undefined);

  const {
    isPending: isUpdatingInternalFixtureRoster,
    isSuccess: isSuccessInternalFixtureRoster,
    mutateAsync: updateInternalFixtureRoster,
  } = useUpdateFixtureRosterPlayerInternal();
  const {
    isPending: isUpdatingDcFixtureRoster,
    isSuccess: isSuccessDcFixtureRoster,
    mutateAsync: updateDcFixtureRoster,
  } = useUpdateFixtureRosterPlayerDc();

  const mutateAsync = useCallback(
    async ({ entityId, seasonId, fixtureId, personId, dcPersonId, data, record }: Props & { fixtureId: string }) => {
      lastUpdateRef.current = record;

      if (personId) {
        await updateInternalFixtureRoster({
          entityId,
          seasonId,
          fixtureId,
          personId: personId || "undefined",
          data,
        });
      } else if (dcPersonId) {
        await updateDcFixtureRoster({
          entityId,
          seasonId,
          fixtureId,
          dcPersonId: dcPersonId || "undefined",
          data,
        });
      }
    },
    [updateInternalFixtureRoster, updateDcFixtureRoster]
  );

  const isUpdating = isUpdatingInternalFixtureRoster || isUpdatingDcFixtureRoster;

  return {
    updatingRecord: isUpdating ? lastUpdateRef.current : undefined,
    mutateAsync,
    isUpdating,
    isSuccess: isSuccessInternalFixtureRoster && isSuccessDcFixtureRoster,
  };
};
